module.exports = __webpack_public_path__ + "img/goodsA1.84845cdc.png";